var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertCircle = function SvgAlertCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 122,
    fill: "none",
    viewBox: "0 0 122 122"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M61 0c16.843 0 32.094 6.829 43.133 17.867C115.171 28.906 122 44.157 122 61s-6.829 32.094-17.867 43.133C93.094 115.171 77.843 122 61 122s-32.094-6.829-43.133-17.867C6.83 93.094 0 77.843 0 61s6.829-32.094 17.867-43.133C28.906 6.83 44.157 0 61 0m4.657 72.028c-.21 5.257-9.113 5.264-9.316-.002-.9-9.008-3.204-30.393-3.13-38.857.074-2.608 2.236-4.152 5.001-4.742.853-.182 1.79-.27 2.735-.27.95.002 1.89.096 2.743.278 2.857.609 5.1 2.217 5.1 4.872l-.011.266zM61 81.37a6.236 6.236 0 1 1 0 12.471 6.236 6.236 0 0 1 0-12.47m0-74.35c29.812 0 53.979 24.167 53.979 53.979S90.812 114.979 61 114.979 7.02 90.812 7.02 61 31.189 7.02 61 7.02",
    clipRule: "evenodd"
  })));
};
export default SvgAlertCircle;